import { Box } from "@mui/material";
import React, { useState, useEffect } from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import Main from './ProductReceipt/Main';
import Form from './ProductReceipt/Form';

import {
  getDataWithComp,
  getDocStatusColour,
  getAlert,
  getMaxRecNo,
  getClearLocalStorage
} from '../../../utils/SamuiUtils';

import { getReport } from '../../../utils/ReportUtils';

function ProductReceipt() {
  const [mode, setMode] = useState('');
  const [dataMasterList, setDataMasterList] = useState([]);
  const [statusColours, setStatusColours] = useState([]);
  const [maxRecNo, setMaxRecNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp('API_0301_REC_H', 'ORDER BY Rec_No DESC');

      // const detailList = await getDataWithComp('API_0302_REC_D', '');
      const docStatusColour = await getDocStatusColour('POREC', 'Rec_Status');

      if (masterList && masterList.length > 0) {
        const sortedData = masterList.sort((a, b) => a.Rec_No - b.Rec_No);
        setDataMasterList(sortedData);
      }

      if (docStatusColour && docStatusColour.length > 0) {
        setStatusColours(docStatusColour);
      }

      // หาค่าสูงของ RecNo ใน REC_H
      const findMaxRecNo = await getDataWithComp('REC_H', 'ORDER BY Rec_No DESC');
      const maxRec = getMaxRecNo(findMaxRecNo);
      setMaxRecNo(maxRec);
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const initialize = async () => {
    try {
      await getClearLocalStorage();
      setMode('S');
      fetchRealtime();
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const onPageInsert = () => {
    setMode('I')
  };

  const onRowSelected = (recNo) => {
    setMaxRecNo(recNo);
    setMode('U');
  };

  return (
    <Box className="ProductReceipt" sx={{ display: 'flex' }}>
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, ml: 'var(--sidebar-width, 220px)', p: 3 }}>
        {mode === 'S' ? (
          <Main
            masterList={dataMasterList}
            statusColours={statusColours}
            name={'ใบรับสินค้า'}
            onPageInsert={onPageInsert}
            onRowSelected={onRowSelected}
            getReport={getReport}
          />
        ) : (
          <Form
            callInitialize={initialize}
            mode={mode}
            setMode={setMode}
            name={'ใบรับสินค้า'}
            maxRecNo={maxRecNo}
            getReport={getReport}
          />
        )}
      </Box>
    </Box>
  );
}

export default ProductReceipt;
